import React from "react";
import { useInView } from "./useInView";
import "./animate.css";

const ScrollRevealSection = ({ children }) => {
  // usestate
  const [ref, isVisible] = useInView();

  return (
    <div ref={ref} className={`scroll-section ${isVisible ? "visible" : ""}`}>
      {children}
    </div>
  );
};

export default ScrollRevealSection